import { render, staticRenderFns } from "./WhatsAppDialog.vue?vue&type=template&id=96a43bd2&"
import script from "./WhatsAppDialog.vue?vue&type=script&lang=js&"
export * from "./WhatsAppDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports